var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBookmarkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 46,
    viewBox: "0 0 38 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 8.33333C26.1051 8.33333 27.1649 8.77232 27.9463 9.55372C28.7277 10.3351 29.1667 11.3949 29.1667 12.5V45.8333L14.5833 39.5833L0 45.8333V12.5C0 11.3949 0.438987 10.3351 1.22039 9.55372C2.00179 8.77232 3.0616 8.33333 4.16667 8.33333H25ZM12.5 0H33.3333C34.4384 0 35.4982 0.438987 36.2796 1.22039C37.061 2.00179 37.5 3.0616 37.5 4.16667V37.5L33.3333 35.6875V4.16667H8.33333C8.33333 3.0616 8.77232 2.00179 9.55372 1.22039C10.3351 0.438987 11.3949 0 12.5 0Z",
    fill: "#4EB9FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmarkIcon);
export default __webpack_public_path__ + "static/media/bookmarkIcon.96cfeffc2275411013c1a268e9377873.svg";
export { ForwardRef as ReactComponent };